import {PeriodType} from "../../../../types";
import { ReportPeriodsData } from "./report-period-type";

export interface IReportPeriod {
  type: PeriodType;
  startDate: Date;
  endDate: Date;
}

export class ReportPeriod implements IReportPeriod{
  type: PeriodType;
  private _startDate: Date;
  private _endDate: Date;

  get startDate(): Date {
    return this._startDate;
  }

  get endDate(): Date {
    return this._endDate;
  }

  set startDate(date: Date) {
    this._startDate = new Date(date);
  }

  set endDate(date: Date) {
    this._endDate = new Date(date);
  }

  constructor(type: PeriodType) {
    this.type = type;
    this._endDate = new Date();
    this._startDate = this.calculateStartDate();
  }

  private calculateStartDate(): Date {
    const calculatedDate = new Date(this.endDate);
    const monthsToSubtract = ReportPeriodsData.getPeriodByName(this.type)?.value || 0;
    calculatedDate.setMonth(this._endDate.getMonth() - monthsToSubtract);

    if (calculatedDate.getDate() !== this.endDate.getDate()) {
      calculatedDate.setDate(0);
    }

    return calculatedDate;
  }

  setDatesPeriod(start: Date, end: Date): void {
    this.startDate = start;
    this.endDate = end;
  }
}
